import { render, staticRenderFns } from "./SwSwitch.vue?vue&type=template&id=2f5a7003"
import script from "./SwSwitch.vue?vue&type=script&lang=js"
export * from "./SwSwitch.vue?vue&type=script&lang=js"
import style0 from "./SwSwitch.vue?vue&type=style&index=0&id=2f5a7003&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports